import { request } from '../api';

export const getRecipes = (action) => {
  const payload: any = {
    url: `/recipes`,
    options: {
      method: 'GET'
    }
  };

  return request(action, { payload });
};
export const getDeviceSettingMap = (action) => {
  const payload: any = {
    url: `/devices/available-settings`,
    options: {
      method: 'GET'
    }
  };

  return request(action, { payload });
};

export const getRecipeById = (action) => {
  const {
    recipeId
  } = action;

  const payload: any = {
    url: `/recipes/${recipeId}`,
    options: {
      method: 'GET'
    }
  };

  return request(action, { payload });
};

export const addRecipe = (action) => {

  const {
    recipe
  } = action;

  return request(action, {
    payload: {
      url: `/recipes`,
      options: {
        method: 'POST',
        data: recipe
      },
    }
  });
};

export const updateRecipe = (action) => {
  const {
    recipeId,
    recipe
  } = action;

  // Check for forceUpdate before converting to JS
  const hasForceUpdate = recipe && (
    (typeof recipe.get === 'function' && recipe.get('forceUpdate') === true) ||
    (typeof recipe.set === 'function' && recipe.get && recipe.get('forceUpdate') === true) ||
    recipe.forceUpdate === true
  );

  const recipeData = recipe.toJS ? recipe.toJS() : recipe;

  // Ensure forceUpdate is explicitly set if it was in the original recipe
  // Backend route handler will extract it and pass as opts
  // The backend will delete it from the updateData before passing to the model
  if (hasForceUpdate) {
    recipeData.forceUpdate = true;
  }

  return request(action, {
    payload: {
      url: `/recipes/${recipeId}`,
      options: {
        method: 'PATCH',
        data: recipeData
      },
    }
  });
};

export const deleteRecipe = (action) => {
  const {
    recipeId
  } = action;

  return request(action, {
    payload: {
      url: `/recipes/${recipeId}`,
      options: {
        method: 'DELETE'
      },
    }
  });
};

export const addRecipeCondition = (action) => {
  const {
    recipeId,
    recipeCondition
  } = action;

  return request(action, {
    payload: {
      url: `/recipes/${recipeId}/condition`,
      options: {
        method: 'PATCH',
        data: recipeCondition
      },
    }
  });
};

export const updateRecipeCondition = (action) => {
  const {
    recipeId,
    recipeCondition
  } = action;

  // Check for forceUpdate before converting to JS
  const hasForceUpdate = recipeCondition && (
    (typeof recipeCondition.get === 'function' && recipeCondition.get('forceUpdate') === true) ||
    (typeof recipeCondition.set === 'function' && recipeCondition.get && recipeCondition.get('forceUpdate') === true) ||
    recipeCondition.forceUpdate === true
  );

  const conditionData = recipeCondition.toJS ? recipeCondition.toJS() : recipeCondition;

  // Ensure forceUpdate is explicitly set if it was in the original condition
  // Backend route handler will extract it and pass to the model method
  if (hasForceUpdate) {
    conditionData.forceUpdate = true;
  }

  return request(action, {
    payload: {
      url: `/recipes/${recipeId}/condition`,
      options: {
        method: 'PATCH',
        data: conditionData
      },
    }
  });
};
